let state = {
    alert: {
        isShow: false,
        data: {}
    },
    confirm: {
        isShow: false,
        data: {}
    },
    titleConfirm: {
        isShow: false,
        data: {}
    },
    isShowRegisterTip: true,
    mixinTransfer_upk: '', //第三方登录中间页upk
    baidu_bindTokenSign: {} //百度第三方登录
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js